module.exports = __webpack_public_path__ + "static/media/o.03598ee9.png";